import { ReactComponentElement, JSXElementConstructor } from "react" //eslint-disable-line
import React from "react"
import { Redirect, Route } from 'react-router-dom'
import { RouteProps } from 'react-router-dom' //eslint-disable-line
import { ConnectedComponent } from "react-redux" //eslint-disable-line
import { Loader } from "components/visuals/loader"
import { setTitle } from "helpers/methods/pageTitle"

/**
 * @typedef {object} _PrivateRouteProps
 * @property {boolean} isAuthenticated Is user authentificated
 * @property {boolean} isInit Is app init
 * @property {boolean=} isAuthorized Is user authorized to access this route
 * @property {string | function(object):string=} title Page name
 * @property {ReactComponentElement | ConnectedComponent<any, any> | JSXElementConstructor<any>} component Component to render
 * 
 * @typedef {_PrivateRouteProps & RouteProps} PrivateRouteProps
 */

/**
 * Component for private route when we need to be authentified
 * @param {PrivateRouteProps} props 
 */
export const PrivateRoute = (props) => {
	if (!!props.title)
		setTitle(getTitle(props))

	return (
		<Route
			{...{ ...props, component: undefined }}
			render={routeProps =>
				props.isAuthenticated ?
					props.isInit ?
						props.isAuthorized === false ?
							<Redirect
								to={{
									pathname: '/',
									state: { from: props.location }
								}}
							/>
							:
							<props.component {...routeProps} />
						:
						<Loader />
					:
					<Redirect
						to={{
							pathname: '/login',
							state: { from: props.location }
						}}
					/>
			}
		/>
	)
}


/**
 * @typedef {object} _PublicRouteProps
 * @property {string | function(object):string} title Page name
 * @property {ReactComponentElement | ConnectedComponent<any, any>} component Component to render
 * 
 * @typedef {_PublicRouteProps & RouteProps} PublicRouteProps
 */

/**
 * Component for private route when we need to be authentified
 * @param {PublicRouteProps} props 
 */
export const PublicRoute = (props) => {
	setTitle(getTitle(props))
	return (
		<Route {...props} />
	)
}

/**
 * Get title when props.title is a function or string
 * @param {object} props 
 * @returns {string} Title
 */
const getTitle = (props) => typeof props.title === "function" ? props.title(props.computedMatch.params) : props.title